import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  AuthService,
  BalanceQuery,
  Card,
  CardQuery,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  config,
} from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
  animations: [
      trigger('expandAnimation', [
        state('open', style({ transform: 'rotate(0deg)' })),
        state('close', style({ transform: 'rotate(180deg)' })),
        transition('open <=> close', [animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
      ]),
    ],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  pointsBalance$: Observable<number | undefined>;
  selectedMember: string;
  cards$: Observable<Card[]>;
  currentUrl: string = '';
  productCode = ProductCode;

  constructor(
    private authService: AuthService,
    private router: Router,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private cardQuery: CardQuery,
    private balanceQuery: BalanceQuery
  ) {}
  private routerSubscription: Subscription;
  public isCollapsed = true;

  ngOnInit() {
    this.currentUrl = window.location.pathname;
    this.initMemberAccounts();
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap((navigation: any) => {
          this.currentUrl = navigation.url;
          return (this.isCollapsed = true);
        })
      )
      .subscribe();
  }

  initMemberAccounts() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.cards$ = this.cardQuery.selectCards();
    this.selectedMember = this.memberQuery.getUserContext().memberId;
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  closeMobileNav() {
    window.location.pathname === this.currentUrl && (this.isCollapsed = !this.isCollapsed);
  }

  logout() {
    this.authService
      .logout()
      .toPromise()
      .then(() => this.router.navigate(['/login']));
  }
}
